module.exports = __webpack_public_path__ + "img/307-29b42e.png";